import React from "react";
import { Modal, Button } from "react-bootstrap";

function AboutModal(props) {
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3>About - Let's Teach English Program</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <p>Let's Teach English is an ACT (APR Charitable Trust) initiative. The purpose of this initiative is to teach English to underprivileged individuals (Age: 8-99). It is a distance learning programme. We thank you for volunteering your valuable time and commitment towards this initiative.</p> */}
        <p>
          Let's Teach English is an ACT (APR Charitable Trust) initiative. The
          purpose of this initiative is to teach English to underprivileged
          individuals (Age: 8-99). It is a distance learning programme. We thank
          you for committing your valuable time towards this initiative
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="primary" onClick={props.onHide}>
          CLOSE
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AboutModal;
